export const HandoverURLTestRoutes = {
    ROOT: "/handover-url-test",
};


// WEBPACK FOOTER //
// ./src/components/handoverURLTest/HandoverURLTestRoutes.ts